import React from 'react';
import AdminDailyChecks from '../admin-daily-checks';
const JKHiveDailyChecks = () => <AdminDailyChecks />;
export default JKHiveDailyChecks;
